export default "__VITE_ASSET__BMX48eM4__"